import React from "react";
import { observer } from "mobx-react";
import { AiSearchPatternUpdateStore } from "../../store";
import { AiSearchPatternUpdateForm } from "./AiSearchPatternUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";

export type AiSearchPatternUpdateProps = {
  aiSearchPatternUpdateStore: AiSearchPatternUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const AiSearchPatternUpdate: React.FC<AiSearchPatternUpdateProps> =
  observer(
    ({ aiSearchPatternUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={aiSearchPatternUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={aiSearchPatternUpdateStore.savedButOutdated}
            onReload={() => aiSearchPatternUpdateStore.reloadAiSearchPattern()}
            reloadDisabled={aiSearchPatternUpdateStore.isProcessing}
          />
          <AiSearchPatternUpdateForm
            aiSearchPatternUpdateStore={aiSearchPatternUpdateStore}
            nameError={aiSearchPatternUpdateStore.errors.name?.message}
            onNameChange={(value: string) => {
              aiSearchPatternUpdateStore.setNameValue(value);
            }}
            name={aiSearchPatternUpdateStore.entityValues.name}
            descriptionError={
              aiSearchPatternUpdateStore.errors.description?.message
            }
            onDescriptionChange={(value: string) => {
              aiSearchPatternUpdateStore.setDescriptionValue(value);
            }}
            description={aiSearchPatternUpdateStore.entityValues.description}
            patternError={aiSearchPatternUpdateStore.errors.pattern?.message}
            onPatternChange={(value: string) => {
              aiSearchPatternUpdateStore.setPatternValue(value);
            }}
            pattern={aiSearchPatternUpdateStore.entityValues.pattern}
            pathTypesError={
              aiSearchPatternUpdateStore.errors.pathTypes?.message
            }
            onPathTypesChange={(value: string[]) => {
              aiSearchPatternUpdateStore.setPathTypesValue(value);
            }}
            pathTypes={aiSearchPatternUpdateStore.entityValues.pathTypes}
            toolsError={aiSearchPatternUpdateStore.errors.tools?.message}
            onToolsChange={(value: string[]) => {
              aiSearchPatternUpdateStore.setToolsValue(value);
            }}
            tools={aiSearchPatternUpdateStore.entityValues.tools}
            effectivenessError={
              aiSearchPatternUpdateStore.errors.effectiveness?.message
            }
            onEffectivenessChange={(value: number | undefined) => {
              aiSearchPatternUpdateStore.setEffectivenessValue(value);
            }}
            effectiveness={
              aiSearchPatternUpdateStore.entityValues.effectiveness
            }
            evaluationCountError={
              aiSearchPatternUpdateStore.errors.evaluationCount?.message
            }
            onEvaluationCountChange={(value: number) => {
              aiSearchPatternUpdateStore.setEvaluationCountValue(value);
            }}
            evaluationCount={
              aiSearchPatternUpdateStore.entityValues.evaluationCount
            }
            successCountError={
              aiSearchPatternUpdateStore.errors.successCount?.message
            }
            onSuccessCountChange={(value: number) => {
              aiSearchPatternUpdateStore.setSuccessCountValue(value);
            }}
            successCount={aiSearchPatternUpdateStore.entityValues.successCount}
            sourceEvalIdsError={
              aiSearchPatternUpdateStore.errors.sourceEvalIds?.message
            }
            onSourceEvalIdsChange={(value: string[]) => {
              aiSearchPatternUpdateStore.setSourceEvalIdsValue(value);
            }}
            sourceEvalIds={
              aiSearchPatternUpdateStore.entityValues.sourceEvalIds
            }
            proposedByError={
              aiSearchPatternUpdateStore.errors.proposedBy?.message
            }
            onProposedByChange={(value: string) => {
              aiSearchPatternUpdateStore.setProposedByValue(value);
            }}
            proposedBy={aiSearchPatternUpdateStore.entityValues.proposedBy}
            activeError={aiSearchPatternUpdateStore.errors.active?.message}
            onActiveChange={(value: boolean) => {
              aiSearchPatternUpdateStore.setActiveValue(value);
            }}
            active={aiSearchPatternUpdateStore.entityValues.active}
            priorityError={aiSearchPatternUpdateStore.errors.priority?.message}
            onPriorityChange={(value: number) => {
              aiSearchPatternUpdateStore.setPriorityValue(value);
            }}
            priority={aiSearchPatternUpdateStore.entityValues.priority}
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={aiSearchPatternUpdateStore.saveDisabled}
            onSave={() => aiSearchPatternUpdateStore.saveAiSearchPattern()}
            onCancel={() => aiSearchPatternUpdateStore.cancelAiSearchPattern()}
          />
          <ErrorDialog
            open={aiSearchPatternUpdateStore.errorDialogOpened}
            title={aiSearchPatternUpdateStore.errorTitle}
            description={aiSearchPatternUpdateStore.errorDescription}
            onClose={() => aiSearchPatternUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={aiSearchPatternUpdateStore.confirmDialogOpened}
            title={aiSearchPatternUpdateStore.confirmDialogTitle}
            description={aiSearchPatternUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              aiSearchPatternUpdateStore.executeConfirmedAction()
            }
            onCancel={() => aiSearchPatternUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
